/** Legacy: S = automática (sistema), M = manual. N/null/vacío se tratan como automática. */
export function esNumeracionManualSucVenta(numPropio?: string | null): boolean {
  return String(numPropio ?? '').trim().toUpperCase().startsWith('M');
}

export function normalizarNumPropioSucVenta(numPropio?: string | null): 'S' | 'M' {
  return esNumeracionManualSucVenta(numPropio) ? 'M' : 'S';
}
